import { CompanyTier } from '../../../../services/exports/Constants';

export default {
  [CompanyTier.Vip]: 'VIP',
  [CompanyTier.Star]: 'Ster',
  [CompanyTier.B]: 'B',
  [CompanyTier.C]: 'C',
  [CompanyTier.D]: 'D',
};
